<template>
    <div class="companies-view">
        <company-return-menu  />
        <!-- <return-menu v-bind:ReturnMenuSettings="ReturnMenuSettings"/> -->
        <section class="companies-landing --digitalpath dp-mobile">
            <div class="dark-filter"></div>
            <div class="comp-logo"><router-link to="/home"><img width="150px" src="../assets/imgs/icons/global-choices-logo-white.png"> </router-link></div>
            <div class="intro-hd-container">
                <img src="../assets/imgs/icons/dp-infinity-symbol.png">
                <img src="../assets/imgs/icons/dp-logo-white.png">
                 
                <p class="content-text --fl --prim">A keen group of professional designers and developers who are solely dedicated to designing incredible customer journeys and thrive off of the ultimate customer experience. Our unique and artistic flair comes through time and time again.
<br><br>
Today’s online marketing and advertising space comprises of the capability to resonate with your users and truly embrace the human connection. There is a sense of authenticity in the air and we can help you in offering value to your users by building meaningful digital solutions that changes lives. The current business environment has a growing need for a 360° client centric business model, and this is driven by rapid technological advancements and digitising your services. Partner with us on your digital journey as your business grows within the era of digital transformation.
</p>
                <a href="http://digitalpath.co.za/" target="_blank" rel="noopener noreferrer" class="btn comps-btn dp-yellow">Start Your Journey</a>
            </div>

            <div class="social-icons-mobile">
                <ul class="social-items">
                    <li><a href="https://www.facebook.com/GlobalChoicesZA/" class="facebook" target="_blank" rel="noopener noreferrer"></a></li>
                    <li><a href="https://twitter.com/GlobalChoicesZA" class="twitter"  target="_blank" rel="noopener noreferrer"></a></li>
                    <li><a href="https://www.linkedin.com/company/global-choices-lifestyle/?originalSubdomain=za" class="linkedin"  target="_blank" rel="noopener noreferrer"></a></li>
                    <li><a href="https://www.instagram.com/globalchoicesza/" class="instagram"  target="_blank" rel="noopener noreferrer"></a></li>
                    <li><a href="https://www.youtube.com/channel/UCbCW_LVHs3zhXqtY6yRETBQ" class="youtube"  target="_blank" rel="noopener noreferrer"></a></li>
                </ul>
            </div>
            <SocialIconsMobile v-bind="SocialIconsMobileSettings" />
        </section>
    </div>
</template>

<script>
import CompanyReturnMenu from '@/components/ui/CompanyReturnMenu'
import SocialIconsMobile from '@/components/ui/SocialIconsMobile'

export default {
    // components: { SocialIconsMobile},
    components: { CompanyReturnMenu,SocialIconsMobile},
     data(){
        return {
            ReturnMenuSettings:{
                colorTheme:false
            },
            SocialIconsMobileSettings:{
                DarkIconsTrue:false
            }
        }
    } 
}
</script>

<style>

</style>
